/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../components/layout/core";

const cabinetBreadCrumbs: Array<PageLink> = [
  {
    title: "Kabinet",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const Cabinet: FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <PageTitle
              description="Umumiy ko’rinish va Sozlamalar"
              breadcrumbs={cabinetBreadCrumbs}
            />
            <Outlet />
          </>
        }
      >
        <Route
          path="overview"
          element={
            <>
              <h1>Umumiy ma’lumotlar</h1>
            </>
          }
        />
        <Route
          path="settings"
          element={
            <>
              <h1>Sozlamalar</h1>
            </>
          }
        />
        <Route index element={<Navigate to={`/profile/overview`} />} />
      </Route>
    </Routes>
  );
};

export { Cabinet };
